<template>
  <el-dialog 
    v-if="isVisible" 
    v-model="isVisible"
    :title="$t('OrderPage[\'Schedule Send Date\']')"
    class="schedule-send-date-dialog order-test"
    @close="close"
  >
    <p class="subtitle">{{ $t("OrderPage[\"Send order to\"]") }}</p>
    <div class="patient-name pl-5 py-2 mt-2">{{ name }}</div>
    <div class="mt-7 flex send-date-time-picker-container">
      <div>
        <p class="subtitle mb-2">{{ $t("OrderPage[\"Select a day\"]") }}</p>
        <DatePicker 
          class="send-date-picker" 
          :default-date-string="formattedDate" 
          @change="date = $event" 
        />
      </div>
      <div class="ml-5">
        <p class="subtitle mb-2">{{ $t("OrderPage[\"Select time\"]") }}</p>
        <el-time-picker
          v-model="time"
          class="order-page-date-picker send-time-picker"
          popper-class="send-time-picker-dropdown"
          format="h:mm A"
          value-format="h:mm A"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:00',
          }"
        />
      </div>
    </div>
    <hr v-if="date" class="mt-12">
    <p v-if="date" class="mt-9 content break-normal">
      {{ $t("OrderPage[\"This order will be automatically sent to { name } on { formattedDate }\"]", { name: name, formattedDate: formattedDate }) }}
      <span v-if="time">at {{ time }}</span>
    </p>
    <div class="text-right">
      <el-button class="mt-8 save-btn" @click="saveDate">{{ $t("OrderPage[\"Save and Schedule\"]") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import DatePicker from "../../../../../components/DatePicker.vue";
import moment from "moment";
import { notify } from '@/utils/notify';

export default {
  components: {
    DatePicker,
  },
  props: {
    isOpenDialog: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isVisible: false,
      date: this.$store.state.orderTest.order.sendDate.date ? new Date(this.$store.state.orderTest.order.sendDate.date) : "",
      time: this.$store.state.orderTest.order.sendDate.time,
      dateFormatOption: { month: "long", day:"numeric", year: "numeric" },
    }
  },
  computed: {
    // get date format: MMMM d, YYYY
    formattedDate() {
      return this.date ? this.date.toLocaleDateString("default", this.dateFormatOption) : "";
    },
  },
  watch: {
    isOpenDialog(newVal) {
      this.isVisible = newVal;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },

    saveDate() {
      if (!this.date) {
        let message = this.$t("OrderPage[\"Please choose a date.\"]");
        notify({ type: 'error', message });        
        return;
      }
      if (!this.time) {
        let message = this.$t("OrderPage[\"Please choose a time.\"]");
        notify({ type: 'error', message });  
        return;
      }
      // error notification for invalid date (chosen date is earlier than today)
      // if time is given, compare both date and time with now
      let date = new Date(this.formattedDate + " " + this.time);
      if (moment(date).isBefore(moment(), "minute")) {
        let message = this.$t("OrderPage[\"Please choose a future date and time.\"]");
        notify({ type: 'error', message });          
        return;
      }
      let dateObj = { date: this.formattedDate, time: this.time };
      this.$store.dispatch("orderTest/order/setSendDate", dateObj);
      this.close();
    },
  },
};
</script>

<style scoped>
.subtitle {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;
  color: #4A4A4A;
}

.patient-name {
  background: #F6F7F7;
  border: 1px solid rgba(0, 0, 0, 0.23);
  box-sizing: border-box;
  border-radius: 4px;

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.4576px;
  color: #000000;
}

.content {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.save-btn {
  height: 42px;
  width: 182px;
  border: 1px solid #20A8C3;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.429px;
  color: #20A8C3;
}
</style>